import * as React from 'react'

const PencilGreyIcon = (props: { className?: string }) => {
  return (
    <svg
      className={'icon ' + props.className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.48004 10.4824L5.45125 13.4535C5.58479 13.587 5.78509 13.587 5.91863 13.4535L13.33 6.00911C13.4635 5.87558 13.4635 5.67528 13.33 5.54175L10.3921 2.60405C10.2586 2.47052 10.0583 2.47052 9.92476 2.60405L2.48004 10.0484C2.3465 10.182 2.3465 10.3823 2.48004 10.4824ZM11.3589 1.23517C11.2254 1.3687 11.2254 1.569 11.3589 1.70253L14.2968 4.64023C14.4303 4.77376 14.6306 4.77376 14.7642 4.64023L15.5988 3.80565C16.1329 3.30491 16.1329 2.50372 15.5988 1.96959L14.0297 0.400595C13.4955 -0.133532 12.6609 -0.133532 12.1268 0.400595L11.3589 1.23517ZM0.00937263 15.4228C-0.0573962 15.7566 0.243063 16.057 0.576907 15.9903L4.21581 15.1223C4.34934 15.0889 4.4495 15.0222 4.51627 14.9554L4.58303 14.8886C4.6498 14.8219 4.68319 14.5882 4.54965 14.4547L1.54505 11.4502C1.41152 11.3167 1.17783 11.3501 1.11106 11.4168L1.04429 11.4836C0.944136 11.5837 0.910751 11.6839 0.877367 11.784L0.00937263 15.4228Z'
        fill='#8C97A2'
      />
    </svg>
  )
}

export default PencilGreyIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/PencilGreyIcon.tsx